import { render, staticRenderFns } from "./LiveStreamForm.vue?vue&type=template&id=479b70c4&scoped=true&"
import script from "./LiveStreamForm.vue?vue&type=script&lang=js&"
export * from "./LiveStreamForm.vue?vue&type=script&lang=js&"
import style0 from "./LiveStreamForm.vue?vue&type=style&index=0&id=479b70c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479b70c4",
  null
  
)

export default component.exports